import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalOptions, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { config } from '@app/service/config.service';

@Component({
  selector: 'app-magazine-contents',
  templateUrl: './magazine-contents.component.html',
  styleUrls: ['./magazine-contents.component.scss']
})
export class MagazineContentsComponent implements OnInit {

  public image: any = '';
  public baseURL: any = config.baseUrl;

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

}
